import React, { PureComponent } from 'react';
import {
  DefaultErrorStyled,
  Icon,
  ErrorWrapper,
  RestrictionIconWrap,
} from './styles/DefaultErrorStyled';

class DefaultError extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <DefaultErrorStyled>
        <ErrorWrapper>
          <RestrictionIconWrap>
            <Icon>
              <path
                fill="#ffffff"
                d="M35 45.995v-.026L1.135 69.282 0 67.635l35-24.1V9.002a1 1 0 0 1 1.573-.82l24.704 17.26L97.5.5l.647 2-1.268.873-.014-.02-33.147 22.848-.682.469-1.758 1.212-.001-.001L37 44.593v.023l-2 1.379zm0 2.429l2-1.379v11.038l33.754-23.581-7.725-5.397 1.757-1.212 8.287 5.789a1 1 0 0 1 0 1.64l-36.5 25.5a1 1 0 0 1-1.573-.82V48.424zm24.519-21.772L37 10.92v31.238l22.519-15.506z"
              />
            </Icon>
          </RestrictionIconWrap>
        </ErrorWrapper>
      </DefaultErrorStyled>
    );
  }
}

export default DefaultError;
